export const EmptyGiftCardError = new Error('Gift card is empty');
export const GiftCardNotFoundError = new Error('Gift card not found');